import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { QueryParamsModel } from "../../_base/crud";
import { OfficeAdjustmentActions, OfficeAdjustmentsActionTypes } from "../_actions/office-adjustments.actions";
import { OfficeAdjustmentModel } from "../_models/office-adjustment.model";

export interface OfficeAdjustmentsState extends EntityState<OfficeAdjustmentModel> {
    isAllAdjustmentsLoaded: boolean;
    queryRowsCount: number;
    queryResult: OfficeAdjustmentModel[];
    lastCreatedAdjustmentId: number;
    listLoading: boolean;
    actionLoading: boolean;
    totalCount: number;
    totalTrashed: number;
    totalAdminTrashed: number;

    lastQuery: QueryParamsModel;
    showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<OfficeAdjustmentModel> = createEntityAdapter<OfficeAdjustmentModel>();

export const initialAdjustmentsState: OfficeAdjustmentsState = adapter.getInitialState({
    isAllAdjustmentsLoaded: false,
    queryRowsCount: 0,
    queryResult: [],
    lastCreatedAdjustmentId: undefined,
    listLoading: false,
    actionLoading: false,
    totalCount: 0,
    totalTrashed: 0,
    totalAdminTrashed: 0,
    lastQuery: new QueryParamsModel({}),
    showInitWaitingMessage: true
});

export function officeAdjustmentssReducer(state = initialAdjustmentsState, action: OfficeAdjustmentActions): OfficeAdjustmentsState {
    switch (action.type) {
        case OfficeAdjustmentsActionTypes.OfficeAdjustmentsPageToggleLoading:
            return {
                ...state, listLoading: action.payload.isLoading, lastCreatedAdjustmentId: undefined
            };
        case OfficeAdjustmentsActionTypes.OfficeAdjustmentActionToggleLoading:
            return {
                ...state, actionLoading: action.payload.isLoading
            };
        case OfficeAdjustmentsActionTypes.OfficeAdjustmentOnServerCreated:
            return {
                ...state
            };
        case OfficeAdjustmentsActionTypes.OfficeAdjustmentCreated:
            return adapter.addOne(action.payload.item, {
                ...state, lastCreatedAdjustmentsId: action.payload.item.id
            });
        case OfficeAdjustmentsActionTypes.OfficeAdjustmentUpdated:
            return adapter.updateOne(action.payload.partialItem, state);

        case OfficeAdjustmentsActionTypes.AllOfficeAdjustmentsLoaded:
            return adapter.addAll(action.payload.items, {
                ...state, isAllAdjustmentssLoaded: true
            });
        case OfficeAdjustmentsActionTypes.OfficeAdjustmentsPageCancelled:
            return {
                ...state, listLoading: false, queryRowsCount: 0, queryResult: [], lastQuery: new QueryParamsModel({})
            };
        case OfficeAdjustmentsActionTypes.OfficeAdjustmentsPageLoaded:
            return adapter.addMany(action.payload.items, {
                ...initialAdjustmentsState,
                totalCount: action.payload.totalCount,
                totalTrashed: action.payload.totalTrashed,
                totalAdminTrashed: action.payload.totalAdminTrashed,
                listLoading: false,
                lastQuery: action.payload.page,
                showInitWaitingMessage: false
            });

        case OfficeAdjustmentsActionTypes.OfficeAdjustmentDeleted:
            return adapter.removeOne(action.payload.id, {
                ...state, totalTrashed: state.totalTrashed + 1
            });

        case OfficeAdjustmentsActionTypes.OfficeAdjustmentRestored:
            return adapter.addOne(action.payload.item, {
                ...state, totalTrashed: state.totalTrashed - 1
            });

        case OfficeAdjustmentsActionTypes.OfficeAdjustmentDeletedFromTrash:
            return {
                ...state, totalTrashed: state.totalTrashed - 1, totalAdminTrashed: state.totalAdminTrashed + 1
            };

        // Admin Trash Action
        case OfficeAdjustmentsActionTypes.OfficeAdjustmentAdminRestored:
            return adapter.addOne(action.payload.item, {
                ...state, totalAdminTrashed: state.totalAdminTrashed - 1
            });

        case OfficeAdjustmentsActionTypes.OfficeAdjustmentDeletedFromAdminTrash:
            return {
                ...state, totalAdminTrashed: state.totalAdminTrashed - 1
            };
        case OfficeAdjustmentsActionTypes.OfficeAdjustmentTrashFlushed:
            return {
                ...state, totalTrashed: 0, totalAdminTrashed: state.totalAdminTrashed + state.totalTrashed
            };
        default:
            return state;
    }
}

export const {
    selectAll,
    selectEntities,
    selectIds,
    selectTotal
} = adapter.getSelectors();